import { cn } from "@newxsystems/shared";
import { AbyssAction } from "../AbyssAction/AbyssAction";
import { AbyssMedia } from "../AbyssMedia/AbyssMedia";
import { AbyssRichText } from "../AbyssRichText/AbyssRichText";
import type { IHeroBackgroundImageProps } from "./HeroBackgroundImage.props";

export const HeroBackgroundImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroBackgroundImageProps) => {
  const centered = alignment === "center";
  return (
    <div
      className="abyss-instrument-frame relative flex min-h-[36rem] overflow-hidden rounded-xl border border-iron bg-absolute-black shadow-[0_32px_100px_rgba(0,0,0,0.36)] md:min-h-[44rem]"
      data-calibrated="true"
    >
      <AbyssMedia
        className="absolute inset-0 h-full"
        imageClassName="object-cover"
        media={image.image}
        priority
        sizes="(min-width: 1536px) 1440px, calc(100vw - 48px)"
      />
      <div
        className={cn(
          "absolute inset-0",
          centered
            ? "bg-[radial-gradient(circle_at_50%_78%,rgba(2,3,4,0.58)_0%,rgba(2,3,4,0.9)_72%),linear-gradient(0deg,rgba(2,3,4,0.92)_0%,transparent_70%)]"
            : "bg-[linear-gradient(90deg,rgba(2,3,4,0.96)_0%,rgba(2,3,4,0.74)_44%,rgba(2,3,4,0.08)_78%),linear-gradient(0deg,rgba(2,3,4,0.92)_0%,transparent_62%)]",
        )}
      />
      <div className="relative z-10 flex w-full items-end p-7 md:p-12 lg:p-16">
        <div className={cn("w-full max-w-[58rem] text-frost", centered && "mx-auto text-center")}>
          <div className={cn("flex flex-col gap-5", centered && "items-center")}>
            {eyebrow ? (
              <p
                className={cn(
                  "abyss-kicker text-frost before:bg-frost/55",
                  centered && "before:hidden",
                )}
              >
                {eyebrow}
              </p>
            ) : null}
            {heading ? (
              <h1 className="abyss-type-hero max-w-[15ch] font-abyss-display font-medium">
                {heading}
              </h1>
            ) : null}
            {description ? (
              <AbyssRichText className="max-w-[60ch] text-frost" content={description} />
            ) : null}
            {buttons?.length ? (
              <div className={cn("flex flex-wrap gap-3 pt-2", centered && "justify-center")}>
                {buttons.map((button, index) => (
                  <AbyssAction action={button} key={`${button.href}-${index}`} />
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

HeroBackgroundImage.displayName = "Content::HeroBackgroundImage";
